var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepManagementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "-2.25 -1.875 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.75H12V9.75H9V8.25H12V2.25H10.5V6L7.5 4.8V12.75ZM6 12.75V4.8L3 6V2.25H1.5V12.75H6ZM3 0.75V0H10.5V0.75H12.75C12.9489 0.75 13.1397 0.829018 13.2803 0.96967C13.421 1.11032 13.5 1.30109 13.5 1.5V13.5C13.5 13.6989 13.421 13.8897 13.2803 14.0303C13.1397 14.171 12.9489 14.25 12.75 14.25H0.75C0.551088 14.25 0.360322 14.171 0.21967 14.0303C0.0790176 13.8897 0 13.6989 0 13.5V1.5C0 1.30109 0.0790176 1.11032 0.21967 0.96967C0.360322 0.829018 0.551088 0.75 0.75 0.75H3ZM6.75 3.75L9.375 1.5H4.125L6.75 3.75Z",
    fill: "#6C737F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepManagementIcon);
export default __webpack_public_path__ + "static/media/rep-management-icon.764871372914ac91dbb82f20fc86581f.svg";
export { ForwardRef as ReactComponent };